export default __webpack_public_path__ + "b9929e5aab3d9b64c95aaf26870d24c8.png";